import React, { useState } from "react";
import {
    Edit,
    TextInput,
    ReferenceInput,
    SimpleForm,
    required,
    useNotify,
    useRefresh,
    AutocompleteInput,
    DateInput,
    NumberInput,
    SaveButton,
    Toolbar,
    SelectInput,
} from "react-admin";
import { GenericTable } from "../__common/GenericTable";

import { makeStyles } from "@material-ui/core/styles";

import { MyEditActions } from "../__common/MyEditActions";
import { AntibioticInterpretationField } from "./AntibioticInterpretationField";
import { DiscreteAntibioticInterpretationField } from "./DiscreteAntibioticInterpretationField";

const useEditStyles = makeStyles({
    root: { alignItems: "flex-start" },

    box: {
        width: "100%",
    },
    grid: {
        width: "100%",
    },
    textInput: {
        width: "auto",
    },
});

const ExternalIsolateEditToolbar = (props) => {

    return (
        <Toolbar {...props}>
            <SaveButton
                label="Save"
                submitOnEnter={false}
            />
            <span>&nbsp;</span>
        </Toolbar>
    );
};


export const ExternalIsolatesEdit = (props) => {
    const [reload, setReload] = useState(0);

    const onChange = ()=>{
        setReload(p => p + 1);
    }

    const classes = useEditStyles();

    const notify = useNotify();
    const refresh = useRefresh();
    const onSuccess = () => {
        notify(`Changes saved`);
        refresh();
    };

    return (
        <Edit
            title="Edit External Isolate"
            undoable={false}
            onSuccess={onSuccess}
            submitOnEnter={true}
            actions={<MyEditActions />}
            {...props}
            classes={classes}
        >
            <SimpleForm onChange={onChange} toolbar={<ExternalIsolateEditToolbar/>}>
                {/* <AjustarColecciones></AjustarColecciones> */}
                <TextInput label="Code" source="code" />
                <TextInput label="Code external" source="code_external" />
                <TextInput label="Code external" source="type_external" />
                <ReferenceInput
                    label="Provider"
                    source="id_provider"
                    reference="providers"
                    validate={required()}
                >
                    <AutocompleteInput
                        resettable={true}
                        clearAlwaysVisible={true}
                        optionText="name"
                        suggestionLimit={9999}
                    />
                </ReferenceInput>

                <TextInput label="Specie" source="specie" />
                <TextInput label="Study source" source="study_source" />

                <DateInput label="Study date" source="study_date" />

                <TextInput label="Notes" source="notes" multiline minRows={6} />

                {/* Storage */}

                <div className="title-subsection">STORAGE</div>

                <ReferenceInput
                    perPage={999999} // FIXME: This is a hack to avoid the "perPage" error
                    label="Storage"
                    source="isolates_storages[0].id_storage"
                    reference="storages"
                >
                    <SelectInput fullWidth optionText="storage" />
                </ReferenceInput>
                <TextInput
                    source="isolates_storages[0].cryobox_name"
                    label="Cryobox name"
                />
                <NumberInput
                    source="isolates_storages[0].cryobox_size"
                    label="Size"
                    initialValue="81"
                />
                <TextInput
                    source="isolates_storages[0].cryobox_position"
                    label="Position"
                />
                <TextInput
                    source="isolates_storages[0].notes"
                    label="Notes"
                    multiline
                    minRows={6}
                />
                <br></br>
                <GenericTable
                    reload={reload}
                    collectionName="antibiotics_interpretations"
                    body={{
                        id: undefined,
                        interpretation: undefined,
                        mic_op: undefined,
                        mic_value: undefined,
                        notes: undefined,
                    }}
                    headers={["Antibiotic", "Interpretation", "Mic Operator", "Mic Value", "Notes"]}
                    genericTableRow={AntibioticInterpretationField}
                >
                </GenericTable>
                <br></br>
                <GenericTable
                    collectionName="antibiotics_discrete"
                    body={{
                        id: undefined,
                        mic_interpretation: 'P',
                        notes: undefined,
                    }}
                    headers={["Antibiotic", "Interpretation", "Notes"]}
                    genericTableRow={DiscreteAntibioticInterpretationField}
                >
                </GenericTable>
            </SimpleForm>
        </Edit>
    );
};
